import CardDiv from "modules/common/card-div/CardDiv";
import React, { useEffect, useMemo, useState } from "react";
import { Button, DatePicker, Tabs } from "antd";
const { RangePicker } = DatePicker;
import { useMtdReport } from "./store";
import moment from "moment";
import MonthBarGraph from "./MonthBarGrah";
import MonthComparisonCards from "./MonthComparisonCards";
import { fourPlaceHolder } from "modules/utilities/utility";
import { toast } from "react-toastify";

function MonthReport() {
  const [dateRange1, setDateRange1] = useState(null);
  const [dateRange2, setDateRange2] = useState(null);
  const [submitFlag, setSubmitFlag] = useState(false);
  const {
    mtdData,
    mtdCancData,
    mtdLoading,
    mtdCancLoading,
    fetchmtdIntervalData,
    fetchmtdIntervalCancRtoData,
  } = useMtdReport();

  const handleButtonClick = () => {
    setSubmitFlag(true);
    if (dateRange1 && dateRange2) {
      const currentStartDate = moment(dateRange1?.[0]).startOf("day").toISOString();
      const currentEndDate = moment(dateRange1?.[1]).endOf("day").toISOString();
      const prevStartDate = moment(dateRange2?.[0]).startOf("day").toISOString();
      const prevEndDate = moment(dateRange2?.[1]).endOf("day").toISOString();

      fetchmtdIntervalData(
        currentStartDate,
        currentEndDate,
        prevStartDate,
        prevEndDate
      );
      fetchmtdIntervalCancRtoData(
        currentStartDate,
        currentEndDate,
        prevStartDate,
        prevEndDate
      );
    } else {
      toast.info("Please select both date ranges before proceeding.");
    }
  };

  const subtractData = (data, cancelData, rtoData) => {
    return {
      totalOrderValue: (data?.totalOrderValue || 0) - (cancelData?.totalOrderValue || 0) - (rtoData?.totalOrderValue || 0),
      male: {
        totalValue: (data?.male?.totalValue || 0) - (cancelData?.male?.totalValue || 0) - (rtoData?.male?.totalValue || 0),
        repeatValue: (data?.male?.repeatValue || 0) - (cancelData?.male?.repeatValue || 0) - (rtoData?.male?.repeatValue || 0),
        newValue: (data?.male?.newValue || 0) - (cancelData?.male?.newValue || 0) - (rtoData?.male?.newValue || 0),
      },
      female: {
        totalValue: (data?.female?.totalValue || 0) - (cancelData?.female?.totalValue || 0) - (rtoData?.female?.totalValue || 0),
        repeatValue: (data?.female?.repeatValue || 0) - (cancelData?.female?.repeatValue || 0) - (rtoData?.female?.repeatValue || 0),
        newValue: (data?.female?.newValue || 0) - (cancelData?.female?.newValue || 0) - (rtoData?.female?.newValue || 0),
      },
    };
  };

  const data = useMemo(() => ({
    currentData: subtractData(mtdData?.currentData, mtdCancData?.currentData?.cancelData, mtdCancData?.currentData?.rtoData),
    previousData: subtractData(mtdData?.previousData, mtdCancData?.previousData?.cancelData, mtdCancData?.previousData?.rtoData),
  }), [mtdData, mtdCancData]);

  const extractDataByType = (mtdCancData, type) => ({
    currentData: mtdCancData?.currentData?.[type] || {},
    previousData: mtdCancData?.previousData?.[type] || {},
  });
  
  const rtoData = useMemo(() => extractDataByType(mtdCancData, "rtoData"), [mtdCancData]);
  const cancelData = useMemo(() => extractDataByType(mtdCancData, "cancelData"), [mtdCancData]);

  const isLoading = mtdLoading || mtdCancLoading;

  return (
    <div>
      <CardDiv
        title={
          <div className="d-flex justify-content-between align-items-center my-n1">
            <div className="fw-bold fs-1 font-poppins">Month wise Report</div>
            <div className="d-flex gap-2 flex-row align-items-center justify-content-center">
              <div>
                <RangePicker
                  onChange={(dates, dateStrings) => setDateRange1(dateStrings)}
                />
              </div>
              <div>
                <RangePicker
                  onChange={(dates, dateStrings) => setDateRange2(dateStrings)}
                />
              </div>
              <div>
                <Button type="primary" onClick={handleButtonClick}>
                  Submit
                </Button>
              </div>
            </div>
          </div>
        }
        component={<div>
            {isLoading ? (
              <div className="mt-5">{fourPlaceHolder()}</div>
            ) : (
              dateRange1 && dateRange2 && submitFlag ?<Tabs type="card" defaultActiveKey="1">
                <Tabs.TabPane key="1" tab="Net data">
                  <div className="mt-n3">
                    <MonthComparisonCards data={data} />
                    <div>
                      <MonthBarGraph data={data} />
                    </div>
                  </div>
                </Tabs.TabPane>
                <Tabs.TabPane key="2" tab="Rto Data">
                  <div>
                    <MonthComparisonCards data={rtoData} />
                    <MonthBarGraph data={rtoData} />
                  </div>
                </Tabs.TabPane>
                <Tabs.TabPane key="3" tab="Cancel Data">
                  <div>
                    <MonthComparisonCards data={cancelData} />
                    <MonthBarGraph data={cancelData} />
                  </div>
                </Tabs.TabPane>
              </Tabs>: <div className="fe-bold fs-1 text-center h-75 font-poppins" style={{minHeight:"70vh"}}>Please Select Date Range First! ⚛️</div>
            )}
          </div>
        }
      />
    </div>
  );
}

export default MonthReport;
